export default __webpack_public_path__ + "d93c48c2dea4e13b93a034257c2e1c8f.svg";